export default __webpack_public_path__ + "static/media/icon_money.9a3c3c85.svg";